import React from 'react'
import NarrativeOcgMobileActions from './NarrativeOcgMobileActions'
import NarrativeOcgDestopActions from './NarrativeOcgDestopActions'
import type { NarrativeOcgActionsProps } from '../../types'

function NarrativeOcgActions(props: NarrativeOcgActionsProps) {
  if (props.isMobile) return <NarrativeOcgMobileActions {...props} />
  return <NarrativeOcgDestopActions {...props} />
}

export default NarrativeOcgActions
